import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';

export {
    CUSTOM_MEGA_MENU_COLUMN_REGION_IDS,
    CUSTOM_MEGA_MENU_NAV_REGION_IDS,
    getMegaMenuCustomNavItemId,
    type MegaMenuCustomNavItem,
    type MegaMenuCustomNavSlot,
} from './mega-menu-custom-nav';

/** Stable Page Designer embedded host id for mega menu dropdown columns. */
export const SNK_MEGA_MENU_DROPDOWNS_COMPONENT_ID = 'snk-mega-menu-dropdowns';

export const BRANDS_MEGAMENU_COLUMN_4_REGION_ID = 'brands_megamenu_column_4';

export const NEW_IN_MEGAMENU_COLUMN_2_REGION_ID = 'new_in_megamenu_column_2';
export const NEW_IN_MEGAMENU_COLUMN_3_REGION_ID = 'new_in_megamenu_column_3';
export const NEW_IN_MEGAMENU_COLUMN_4_REGION_ID = 'new_in_megamenu_column_4';

export const OFFERS_MEGAMENU_COLUMN_1_REGION_ID = 'offers_megamenu_column_1';
export const OFFERS_MEGAMENU_COLUMN_2_REGION_ID = 'offers_megamenu_column_2';
export const OFFERS_MEGAMENU_COLUMN_3_REGION_ID = 'offers_megamenu_column_3';

export const INSIDE_SPACE_MEGAMENU_COLUMN_2_REGION_ID = 'inside_space_megamenu_column_2';
export const INSIDE_SPACE_MEGAMENU_COLUMN_3_REGION_ID = 'inside_space_megamenu_column_3';
export const INSIDE_SPACE_MEGAMENU_COLUMN_4_REGION_ID = 'inside_space_megamenu_column_4';

export const TRENDING_MEGAMENU_COLUMN_3_REGION_ID = 'trending_megamenu_column_3';
export const TRENDING_MEGAMENU_COLUMN_4_REGION_ID = 'trending_megamenu_column_4';

export const NEW_IN_CATEGORY_ID = 'new';

export const INSIDE_SPACE_MEGAMENU_PATH = '/inside-space';

export function megaMenuRegionHasContent(
    resolved: ComponentWithComponentData | null | undefined,
    regionId: string
): boolean {
    return (resolved?.regions?.find((region) => region.id === regionId)?.components?.length ?? 0) > 0;
}
